import integ from "./env/integ";
import prod from "./env/prod";
import local from "./env/local";

let config = local;
if (process.env.REACT_APP_ENV === "master") {
  config = prod;
} else if (process.env.REACT_APP_ENV === "release") {
  config = integ;
}

export default config;
